import styled from 'styled-components';

const SelectContainer = styled.div`
  input {
    height: unset;
  }

  display: flex;
  flex-direction: column;
  width: 100%;

  :focus-within {
    > label {
      color: var(--accent);
    }
  }
`;

const Label = styled.label`
  background-color: var(--surface);
  transform: translateY(10px);
  align-self: flex-start;
  padding: 0 10px 0 8px;
  margin-left: 10px;
  color: var(--ink-soft);
  font-size: 1.3rem;
  font-weight: 600;
  z-index: 1;
`;

/**
 * O react-select monta os estilos em JS, então os tokens entram como `var()`
 * — é o que mantém o campo coerente no tema claro e no escuro.
 */
const customStyles = {
  control: (styles, { isFocused }) => ({
    ...styles,
    backgroundColor: 'var(--surface)',
    boxShadow: isFocused ? '0 0 0 3px var(--accent-tint)' : 'none',
    border: isFocused
      ? '1px solid var(--accent) !important'
      : '1px solid var(--border-strong)',
    borderRadius: 'var(--r-sm)',
    ':hover': {
      border: '1px solid var(--border-strong)',
      cursor: 'text',
    },
  }),
  container: styles => ({
    ...styles,
    backgroundColor: 'transparent',
    ':hover': {},
  }),
  option: (styles, { isFocused, isSelected }) => {
    let backgroundColor = 'transparent';
    if (isSelected) backgroundColor = 'var(--accent)';
    else if (isFocused) backgroundColor = 'var(--surface-2)';

    return {
      ...styles,
      backgroundColor,
      color: isSelected ? '#fff' : 'var(--ink)',
      ':active': { backgroundColor: 'var(--accent-tint)' },
    };
  },
  multiValue: styles => ({
    ...styles,
    backgroundColor: 'var(--accent-tint)',
    borderRadius: 'var(--r-pill)',
    fontSize: '1.6rem',
    marginTop: '0.4rem',
    marginLeft: '0.4rem',
  }),
  valueContainer: provided => ({
    ...provided,
    padding: '1.2rem 0.5rem',
  }),
  multiValueLabel: styles => ({
    ...styles,
    color: 'var(--accent-deep)',
  }),
  menu: styles => ({
    ...styles,
    backgroundColor: 'var(--surface)',
    border: '1px solid var(--border)',
    borderRadius: 'var(--r-sm)',
    overflow: 'hidden',
    zIndex: 2,
  }),
  input: styles => ({
    ...styles,
    color: 'var(--ink)',
    marginLeft: '0.8rem',
  }),
  clearIndicator: styles => ({
    ...styles,
    color: 'var(--ink-faint)',
    cursor: 'pointer',
  }),
  placeholder: styles => ({
    ...styles,
    color: 'var(--ink-faint)',
    marginTop: '0.1rem',
    marginLeft: '0.8rem',
  }),
  dropdownIndicator: styles => ({
    ...styles,
    color: 'var(--ink-faint)',
    cursor: 'pointer',
  }),
  singleValue: styles => ({
    ...styles,
    color: 'var(--ink)',
    marginTop: '0.5rem',
    marginLeft: '0.8rem',
  }),
  multiValueRemove: styles => ({
    ...styles,
    color: 'var(--accent-deep)',
    ':hover': {
      color: 'var(--danger)',
      cursor: 'pointer',
    },
  }),
};

export { SelectContainer, Label, customStyles };
